import React, { useState, useEffect, useMemo } from "react";
import InnerBannerBreadcrumb from "../../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import NoticeTab from "./NoticeTab";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import {
  extractDateFromStr,
  getLatestDateFromData,
} from "../../../Utils/utils";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";
import useSeo from "../../../hooks/useSeo";
import { useLocation } from "react-router-dom";

const Notices = () => {
  const [activeTab, setActiveTab] = useState("");
  const { getText } = useLanguageTranslation();
  const { languageType } = useSelector((state) => state.homeSlice);
  const [lastUpdated, setLastUpdated] = useState("");

  const { data: noticeData = [] } = useGetProtectedApiDataQuery({
    url: "notice",
    lang: languageType,
  });

  const transformedNoticeArray = noticeData.reduce((acc, obj) => {
    const category = obj.field_equity_category;
    const categoryEntry = acc.find((item) => item.title === category);
    if (categoryEntry) {
      categoryEntry.data.push(obj);
    } else {
      const id = category === "AGBPS" ? 1 : category === "TGBPS" ? 3 : 2;
      acc.push({ title: category, id, data: [obj] });
    }
    return acc;
  }, []);

  const getLatestNotice = (notices) => {
    return notices.reduce((latest, current) => {
      // If either 'changed' is missing or null, treat it as an old date
      const latestDateMatch = latest?.changed?.match(/datetime="([^"]+)"/);
      const currentDateMatch = current?.changed?.match(/datetime="([^"]+)"/);

      // Convert matched date strings to Date objects, using a very old date as fallback
      const latestDate = latestDateMatch
        ? new Date(latestDateMatch[1])
        : new Date(0);
      const currentDate = currentDateMatch
        ? new Date(currentDateMatch[1])
        : new Date(0);

      // Return the object with the more recent 'changed' date
      return currentDate > latestDate ? current : latest;
    }, notices[0]); // Start with the first item in the array
  };

  useEffect(() => {
    if (transformedNoticeArray.length > 0 && !activeTab) {
      setActiveTab(transformedNoticeArray[0].title);
    }
  }, [transformedNoticeArray, activeTab]);

  const lastUpdatedOn = useMemo(() => {
    return getLatestDateFromData(noticeData);
  }, [noticeData]);

  // for SEO
  const { pathname } = useLocation();
  const { innerBannerImage, innerBannerTitle } = useSeo({ pathname });

  return (
    <>
      <InnerBannerBreadcrumb
        title={getText("Commercial", "वाणिज्यिक ")}
        titleLink="/commercial/notices"
        levelTwo={true}
        levelThree={false}
        bannerImage={innerBannerImage}
        titleTwo={innerBannerTitle}
        isActive={innerBannerTitle}
      />

      <div className="inner-container">
        <div className="container">
          <div className="container">
            <div className="row mt-2">
              <div className="col-12 col-sm-12 col-md-3 col-lg-3 print-left">
                <div className="innleft_section">
                  <ul className="menu nav nav-pills flex-column">
                    {transformedNoticeArray
                      ?.sort((a, b) => a.id - b.id)
                      .map((item, index) => (
                        <li key={index} className="nav-item">
                          <a
                            href="#"
                            className={`nav-link ${
                              activeTab === item.title ? "active" : ""
                            }`}
                            onClick={(e) => {
                              e.preventDefault();
                              setActiveTab(item.title);
                              setLastUpdated(
                                extractDateFromStr(
                                  getLatestNotice(item.data).changed,
                                ),
                              );
                            }}
                          >
                            {item.title}
                          </a>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>

              <div className="col-12 col-sm-12 col-md-9 col-lg-9 print-right">
                {transformedNoticeArray
                  ?.sort((a, b) => a.id - b.id)
                  ?.map(
                    (item, index) =>
                      activeTab === item.title && (
                        <NoticeTab
                          key={index}
                          data={item.data}
                          title={item.title}
                        />
                      ),
                  )}
              </div>
            </div>
            <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Notices;
